module.exports = __webpack_public_path__ + "static/media/sanitizer.eeccad49.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sanitizer.png
// module id = 21
// module chunks = 0